import { schoolTokenAxios, authTokenAxios } from "../axios";

const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;

let aws_url = `${SCHOOL_BASE}/aws`;

export const generatePresignedUrlBySchool = (payload) => {
  return schoolTokenAxios.post(
    `${aws_url}/generatePresignedUrlBySchool`,
    payload
  );
};

export const generatePresignedUrlByIndividual = (payload) => {
  return authTokenAxios.post(
    `${aws_url}/generatePresignedUrlByIndividual`,
    payload
  );
};
